import queryString from 'query-string'

export type CollectionQueryParams = {
  cardName?: string
  syntaxQuery?: string

  collectionOrderBy?: string
  orderDirection?: 'ascending' | 'descending'
  priceSource?: string

  game?: 1 | 2 | 3
  tags?: string // CSV of tagIds

  condition?: string // CSV of conditionIds
  collectionLanguage?: string // CSV of languageIds

  page?: number | string
  pageSize?: number
}

export const setCollectionQueryParams = (params: Partial<CollectionQueryParams>, fullOverride = true) => {
  const { origin, pathname, search } = window.location
  const existingParams: any = queryString.parse(search)

  const newParams: CollectionQueryParams = {}

  if (fullOverride) {
    for (const key of Object.keys(existingParams)) {
      // @ts-ignore
      newParams[key] = existingParams[key]
    }
  }

  for (const key of Object.keys(params)) {
    // @ts-ignore
    newParams[key] = params[key]
  }

  let forcePageParamToOne = false

  if (newParams.collectionOrderBy !== existingParams.collectionOrderBy) forcePageParamToOne = true
  if (newParams.orderDirection !== existingParams.orderDirection) forcePageParamToOne = true
  if (newParams.priceSource !== existingParams.priceSource) forcePageParamToOne = true

  if (forcePageParamToOne) newParams.page = 1

  // @ts-ignore
  window.location = origin + pathname + '?' + queryString.stringify(newParams)
}
